import { sum } from '../../utils/sum.js';
const COLUMN_WIDTH = 140;
export const getHorizontalShift = (columns, activeColumnIndex) => sum(columns.slice(0, activeColumnIndex).map((_) => _?.cols?.length ?? 1)) * COLUMN_WIDTH;
//# sourceMappingURL=getHorizontalShift.js.map